export var ChannelType;
(function (ChannelType) {
    ChannelType[ChannelType["ONLINE"] = 0] = "ONLINE";
    ChannelType[ChannelType["OFFLINE_POS"] = 1] = "OFFLINE_POS";
})(ChannelType || (ChannelType = {}));
export var FeeName;
(function (FeeName) {
    FeeName[FeeName["WIX_FEE"] = 0] = "WIX_FEE";
})(FeeName || (FeeName = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["NA_ORDER_STATUS"] = 0] = "NA_ORDER_STATUS";
    OrderStatus[OrderStatus["FREE"] = 1] = "FREE";
    OrderStatus[OrderStatus["PENDING"] = 2] = "PENDING";
    OrderStatus[OrderStatus["PAID"] = 3] = "PAID";
    OrderStatus[OrderStatus["OFFLINE_PENDING"] = 4] = "OFFLINE_PENDING";
    OrderStatus[OrderStatus["INITIATED"] = 5] = "INITIATED";
    OrderStatus[OrderStatus["CANCELED"] = 6] = "CANCELED";
    OrderStatus[OrderStatus["DECLINED"] = 7] = "DECLINED";
    OrderStatus[OrderStatus["AUTHORIZED"] = 8] = "AUTHORIZED";
    OrderStatus[OrderStatus["VOIDED"] = 9] = "VOIDED";
})(OrderStatus || (OrderStatus = {}));
export var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus[ReservationStatus["RESERVATION_PENDING"] = 0] = "RESERVATION_PENDING";
    ReservationStatus[ReservationStatus["RESERVATION_CONFIRMED"] = 1] = "RESERVATION_CONFIRMED";
    ReservationStatus[ReservationStatus["RESERVATION_CANCELED"] = 2] = "RESERVATION_CANCELED";
    ReservationStatus[ReservationStatus["RESERVATION_CANCELED_MANUALLY"] = 3] = "RESERVATION_CANCELED_MANUALLY";
    ReservationStatus[ReservationStatus["RESERVATION_EXPIRED"] = 4] = "RESERVATION_EXPIRED";
})(ReservationStatus || (ReservationStatus = {}));
export var TicketSaleStatus;
(function (TicketSaleStatus) {
    TicketSaleStatus[TicketSaleStatus["SALE_SCHEDULED"] = 0] = "SALE_SCHEDULED";
    TicketSaleStatus[TicketSaleStatus["SALE_STARTED"] = 1] = "SALE_STARTED";
    TicketSaleStatus[TicketSaleStatus["SALE_ENDED"] = 2] = "SALE_ENDED";
})(TicketSaleStatus || (TicketSaleStatus = {}));
export var TicketDefinitionFieldset;
(function (TicketDefinitionFieldset) {
    TicketDefinitionFieldset[TicketDefinitionFieldset["POLICY"] = 0] = "POLICY";
    TicketDefinitionFieldset[TicketDefinitionFieldset["DASHBOARD"] = 1] = "DASHBOARD";
})(TicketDefinitionFieldset || (TicketDefinitionFieldset = {}));
export var GroupBy;
(function (GroupBy) {
    GroupBy[GroupBy["NONE"] = 0] = "NONE";
    GroupBy[GroupBy["EVENT_CREATED_DESC"] = 1] = "EVENT_CREATED_DESC";
    GroupBy[GroupBy["EVENT_CREATED_ASC"] = 2] = "EVENT_CREATED_ASC";
})(GroupBy || (GroupBy = {}));
export var OrderTag;
(function (OrderTag) {
    OrderTag[OrderTag["CONFIRMED"] = 0] = "CONFIRMED";
    OrderTag[OrderTag["UNCONFIRMED"] = 1] = "UNCONFIRMED";
    OrderTag[OrderTag["MEMBER"] = 2] = "MEMBER";
    OrderTag[OrderTag["ARCHIVED"] = 3] = "ARCHIVED";
    OrderTag[OrderTag["NON_ARCHIVED"] = 4] = "NON_ARCHIVED";
    OrderTag[OrderTag["FULLY_CHECKED_IN"] = 5] = "FULLY_CHECKED_IN";
    OrderTag[OrderTag["NOT_FULLY_CHECKED_IN"] = 6] = "NOT_FULLY_CHECKED_IN";
})(OrderTag || (OrderTag = {}));
export var OrderFieldset;
(function (OrderFieldset) {
    OrderFieldset[OrderFieldset["TICKETS"] = 0] = "TICKETS";
    OrderFieldset[OrderFieldset["DETAILS"] = 1] = "DETAILS";
    OrderFieldset[OrderFieldset["FORM"] = 2] = "FORM";
    OrderFieldset[OrderFieldset["INVOICE"] = 3] = "INVOICE";
})(OrderFieldset || (OrderFieldset = {}));
export var TicketFieldset;
(function (TicketFieldset) {
    TicketFieldset[TicketFieldset["GUEST_DETAILS"] = 0] = "GUEST_DETAILS";
    TicketFieldset[TicketFieldset["TICKET_DETAILS"] = 1] = "TICKET_DETAILS";
    TicketFieldset[TicketFieldset["GUEST_FORM"] = 2] = "GUEST_FORM";
})(TicketFieldset || (TicketFieldset = {}));
//# sourceMappingURL=ticketing.js.map